// extracted by mini-css-extract-plugin
export default {"pass-sell-lot":"pass-sell-lot_pass-sell-lot__IFAq8","pass-btn":"pass-sell-lot_pass-btn__PtSTS","sell-btn":"pass-sell-lot_sell-btn__BQoHP"};